import React from 'react'
import PropTypes from 'prop-types'

export default class ControlBar extends React.Component {
    static get propTypes () {
        return {
            children : PropTypes.array.isRequired 
        }
    } 
    render () {
        return (
            <div className="uk-button-group uk-margin uk-flex fdn-search-control-group">
                {this.props.children}
            </div>
        )
    }
}
